import * as ALOOMA from 'consts/alooma';

export const DEVICE_TYPES = {
  IOS: 'ios',
  ANDROID: 'android',
  WEB: 'web',
};

export const DEVICE_TYPES_INIT_STORE_VALUE = [];
export const GENRES_INIT_STORE_VALUE = [];

export const USER_OFFER_TYPES = {
  EARN: 1,
  MY_OFFERS: 2,
};

export const USER_OFFER_TYPE_LIST = [
  { aloomaElement: ALOOMA.ELEMENTS.EARN, text: 'app:earn', type: USER_OFFER_TYPES.EARN },
  { aloomaElement: ALOOMA.ELEMENTS.MY_OFFERS, text: 'app:myActivity', type: USER_OFFER_TYPES.MY_OFFERS },
];

// This param controls karmaEarnList.isMyOffers state:
// "0" - all offers
// "1" - my offers
export const URL_PARMA_USER_OFFER_TYPE = 'user_offer_type';

// This param controls karmaEarnList.offerType state
// It can have one of OFFER_TYPES values
export const URL_PARMA_OFFER_TYPE = 'offer_type';

export const OFFER_TYPES = {
  // ALL: '0',
  PLAY_GAMES: '1',
  ANSWER_SURVEYS: '2',
  // SCAN_RECEIPT: '3',
  // WATCH_VIDEOS: '4',
  OFFERS: '5',
};

export const SURVEY_TITLE_KEYS = [
  'app:karmaEarnSurveyTitle1',
  'app:karmaEarnSurveyTitle2',
  'app:karmaEarnSurveyTitle3',
  'app:karmaEarnSurveyTitle4',
  'app:karmaEarnSurveyTitle5',
  'app:karmaEarnSurveyTitle6',
  'app:karmaEarnSurveyTitle7',
  'app:karmaEarnSurveyTitle8',
  'app:karmaEarnSurveyTitle9',
  'app:karmaEarnSurveyTitle10',
];

export const OFFER_TYPE_LIST = [
  { value: OFFER_TYPES.PLAY_GAMES, aloomaElement: ALOOMA.ELEMENTS.PLAY_GAMES, text: 'app:playGames' },
  { value: OFFER_TYPES.ANSWER_SURVEYS, aloomaElement: ALOOMA.ELEMENTS.ANSWER_SURVEYS, text: 'app:answerSurveys' },
  // { value: OFFER_TYPES.SCAN_RECEIPT, aloomaElement: ALOOMA.ELEMENTS.SCAN_RECEIPT, text: 'app:scanReceipt' },
  // { value: OFFER_TYPES.WATCH_VIDEOS, aloomaElement: ALOOMA.ELEMENTS.WATCH_VIDEOS, text: 'app:watchVideos' },
  { value: OFFER_TYPES.OFFERS, aloomaElement: ALOOMA.ELEMENTS.OFFERS, text: 'app:offers' },
];

export const DEVICE_BUTTONS = [
  {
    value: DEVICE_TYPES.IOS,
    aloomaElement: ALOOMA.ELEMENTS.IOS_GOALS,
    text: 'app:iosGoals',
  },
  {
    value: DEVICE_TYPES.ANDROID,
    aloomaElement: ALOOMA.ELEMENTS.ANDROID_GOALS,
    text: 'app:androidGoals',
  },
  {
    value: DEVICE_TYPES.WEB,
    aloomaElement: ALOOMA.ELEMENTS.WEB_GOALS,
    text: 'app:webGoals',
  },
];

export const OPTIONS_GENRES = [
  { value: 'action_adventure', text: 'app:actionAdventure' },
  { value: 'strategy_role_playing', text: 'app:strategyRolePlaying' },
  { value: 'puzzle_logic', text: 'app:puzzleLogic' },
  { value: 'cards_board_casino', text: 'app:cardsBoardCasino' },
  { value: 'casual_lifestyle', text: 'app:casualLifestyle' },
  { value: 'sports', text: 'app:sports' },
  { value: 'educational', text: 'app:educational' },
];

export const OPTIONS_DEVICES = [
  { value: DEVICE_TYPES.IOS, text: 'iOS' },
  { value: DEVICE_TYPES.ANDROID, text: 'Android' },
  { value: DEVICE_TYPES.WEB, text: 'Win/Mac' },
];
